import React, {createContext, useContext} from 'react';

import type {Config} from './globalConfig';

const ConfigurationContext = createContext<Config>(null);

type ConfigurationProviderProps = {
    children: React.ReactNode;
    config: Config;
};

export function ConfigurationProvider({children, config}: ConfigurationProviderProps) {
    return <ConfigurationContext.Provider value={config}>{children}</ConfigurationContext.Provider>;
}

export function useConfig(): Config {
    return useContext(ConfigurationContext);
}
